'use client';

import React, { useState } from 'react';

import HeaderImages from '@/app/[locale]/[domain]/(default-layout)/info/_components/HeaderImages.tsx';

import ImageGallery from '@cineamo/ui/src/image/ImageGallery';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type InfoHeaderImagesProps = {
    /**
     * Every uploaded picture for the info page gallery (the building + all cinema rooms), primary images
     * first, then each entity's remaining images in stored order, deduplicated (built by buildInfoGalleryImages).
     */
    images: string[];
};

export default function InfoHeaderImages(props: InfoHeaderImagesProps): React.JSX.Element {
    const domainConfiguration = useDomainConfiguration();

    const [galleryImageIndex, setGalleryImageIndex] = useState<number>();

    return (
        <>
            <HeaderImages
                primaryImages={props.images.slice(0, 1)}
                secondaryImages={props.images.slice(1, 5)}
                totalImagesCount={props.images.length}
                primaryVideoUrl={domainConfiguration.websiteConfiguration?.profileVideoUrl}
                onImageClick={(index) => setGalleryImageIndex(index)}
            />
            {galleryImageIndex !== undefined && (
                <ImageGallery
                    images={props.images}
                    currentIndex={galleryImageIndex}
                    open
                    onClose={() => setGalleryImageIndex(undefined)}
                />
            )}
        </>
    );
}
